import { render } from "./BoxPublisher.vue?vue&type=template&id=82558204"
import script from "./BoxPublisher.vue?vue&type=script&setup=true&lang=js"
export * from "./BoxPublisher.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Sources/JavaScript/Extensions/Lfmpublications/Vue/components/BoxPublisher.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "82558204"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('82558204', __exports__)) {
    api.reload('82558204', __exports__)
  }
  
  module.hot.accept("./BoxPublisher.vue?vue&type=template&id=82558204", () => {
    api.rerender('82558204', render)
  })

}


export default __exports__